import React from 'react';

function Shuffler(props) {
  return (
    <svg width={47.334} height={30.21} viewBox="0 0 47.334 30.21" {...props}>
      <path
        fill="#F58473"
        d="M41.09 10.664a1.213 1.213 0 010-1.5l3.7-3.7-3.7-3.7a1.213 1.213 0 010-1.5 1.214 1.214 0 011.5 0l4.393 4.393a1 1 0 01.347.694.824.824 0 01-.347.694l-4.393 4.393a.953.953 0 01-1.5.226zM41.09 29.934a1.213 1.213 0 010-1.5l3.7-3.7-3.7-3.7a1.213 1.213 0 010-1.5 1.214 1.214 0 011.5 0l4.393 4.393a1 1 0 01.347.694.824.824 0 01-.347.694l-4.393 4.393a.953.953 0 01-1.5.226zM16.968 12.037l-5.206-5.418H1.04a1.04 1.04 0 110-2.081h11.185a.824.824 0 01.694.347l5.4 5.84a.985.985 0 010 1.5c-.58.5-1.351-.188-1.351-.188z"
      />
      <path
        fill="#F58473"
        d="M12.34 25.692H1.04a1.04 1.04 0 110-2.081h10.954L30.721 4.884a1 1 0 01.694-.347H44.6a1.04 1.04 0 010 2.081H31.877L13.15 25.346a1.049 1.049 0 01-.81.346z"
      />
      <path
        fill="#F58473"
        d="M44.6 25.693H31.3a.829.829 0 01-.695-.348l-6.029-5.789a1.214 1.214 0 010-1.5 1.081 1.081 0 011.5 0l5.683 5.559H44.6a1.041 1.041 0 010 2.082z"
      />
    </svg>
  );
}

export default Shuffler;
